const INJECTION_STATE_IDLE = 'idle'
const INJECTION_STATE_PROGRESS = 'in progress'
const INJECTION_STATE_COMPLETE = 'complete'
const INJECTION_STATE_ERROR = 'error'

let injectionState = INJECTION_STATE_IDLE;
let injectionError = null;

const injectionCompleteCallbacks = new Set();
const injectionErrorCallbacks = new Set();

export default function injectScript (apiKey) {
  switch (injectionState) {
    case INJECTION_STATE_PROGRESS:
      return new Promise((resolve, reject) => {
        injectionCompleteCallbacks.add(resolve);
        injectionErrorCallbacks.add(reject);
      });

    case INJECTION_STATE_COMPLETE:
      return Promise.resolve();

    case INJECTION_STATE_ERROR:
      if (injectionError) {
        return Promise.reject(injectionError)
      }
      return Promise.reject('Something went wrong during script injection')

    default:
      injectionState = INJECTION_STATE_PROGRESS;
      return new Promise((resolve, reject) => {
        injectionCompleteCallbacks.add(resolve);
        injectionErrorCallbacks.add(reject);
        const script = document.createElement('script')
        script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`
        script.type = 'text/javascript'
        script.async = true
        script.defer = true
        script.addEventListener('load', onInjectSuccess)
        script.addEventListener('error', onInjectError)
        document.body.appendChild(script)
      })
  }
}

function onInjectSuccess (ev) {
  fireAndCleanupCallbacks(injectionCompleteCallbacks)
  emptySet(injectionErrorCallbacks)
  removeListeners(ev.target)
  injectionState = INJECTION_STATE_COMPLETE
}

function onInjectError (ev) {
  injectionError = 'Could not inject the Google Places script.'
  fireAndCleanupCallbacks(injectionErrorCallbacks, injectionError)
  emptySet(injectionCompleteCallbacks)
  removeListeners(ev.target)
  injectionState = INJECTION_STATE_ERROR
}

function fireAndCleanupCallbacks (cbSet, ...args) {
  // fire callbacks with provided args and remove them from the set after fired.
  return cbSet.forEach((cb, unused, set) => {
    cb(...args)
    set.delete(cb)
  })
}

function emptySet (set) {
  // remove all items from a set.
  return set.forEach((el, unused, s) => s.delete(el))
}

function removeListeners (el) {
  // remove listeners from the element
  el.removeEventListener('load', onInjectSuccess)
  el.removeEventListener('error', onInjectError)
}
